/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{StaticBitSet as t}from"./StaticBitSet.js";class a{constructor(a){this._valid=t.create(a),this._data=new Array(a)}has(t){return this._valid.has(t)}set(t,a){this._valid.set(t),this._data[t]=a}get(t){return this._data[t]}}export{a as FeatureSetCache};
